import React from 'react'

function DashboardComingSoon() {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
      <div className="text-center">
        <h3 className="mb-2">Dashboard coming soon</h3>
        <p className="text-muted mb-0">This dashboard is not available for the current application.</p>
      </div>
    </div>
  )
}

export default DashboardComingSoon
